import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Stack,
  Typography,
  Badge,
  Link,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useDispatch } from "react-redux";
import { getAllJoinedAccountList, switchAccount } from "../../appStore/actions/subscriber/action";
import { getProfile } from "../../appStore/actions/profile/action";
import { useNavigate } from "react-router-dom";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import headerNotificationIcon from "../../assets/images/headerNotificationIcon.svg";
import { removeActivityIndicator } from "../../appStore/actions/global/action";
import AlertPopUp from "../../common/AlertPopUp";
import {
  handleAccountSwitchLoading,
  handleSwitchAccountRefresh,
} from "../../appStore/actions/AppState/action";
import useAppSelectors from "../../customHooks/useAppSelectors";
import { colorSchemes, fontSizeSchemes, crossIcon, crossIconDiv } from "../../assets/commonFunction";
import { CheckCircle } from "@mui/icons-material";
import Tick from "../../assets/images/Profile/approve_tick.svg"
import PersonIcon from "../../assets/images/chats/person.svg";

const theme = createTheme({
  palette: {
    primary: {
      main: "#DB0011",
    },
  },
});
const classes = {
  drawerBody: {
    minWidth: "31.25rem",
    maxWidth: "31.25rem",
    height: "100%",
    position: "relative",
  },
  header: {
    backgroundColor: "#F9F8F8",
    color: "#0000",
    padding: "7px 8px",
  },
  iconDiv: crossIconDiv,
  iconn: crossIcon,
};
const SwitchAccount = ({
  setSwitchAccountDrawerOpen,
  setCreateNewOrgAccountDrawerOpen,
}) => {
  const endpoint = window.location.pathname;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isTermConditionChecked, setTermConditionChecked] = useState(false);
  const [isAlertModalOpen, setAlertModalOpen] = useState(false);
  const { currentUserData,joinedAccountList, switchAccountRefresh, indicatorData } = useAppSelectors();

  const getAccountTypeLabel = (accountTypeLabel) =>
    accountTypeLabel === "Workspace" ? "Workspace Account" : accountTypeLabel;


  const handleRedirection = (response, isAtchat) => {
    if (isAtchat) {
      if (response?.accountOwner) {
        if (response?.isFirstGroupCreated && response?.isFirstInviteSent) {
          dispatch(handleSwitchAccountRefresh(!switchAccountRefresh));
        } else if (
          response?.isFirstGroupCreated &&
          !response?.isFirstInviteSent
        ) {
          navigate("/invite");
        } else {
          navigate("/createfirstgroup");
        }
      } else {
        dispatch(handleSwitchAccountRefresh(!switchAccountRefresh));
      }
    } else {
      if (response?.accountOwner) {
        if (response?.isFirstGroupCreated && response?.isFirstInviteSent) {
          navigate("/chat");
        } else if (
          response?.isFirstGroupCreated &&
          !response?.isFirstInviteSent
        ) {
          navigate("/invite");
        } else {
          navigate("/createfirstgroup");
        }
      } else {
        navigate("/chat");
      }
    }
  };

  const handleAccountSwitch = (subscriber_id) => {
    if (currentUserData?.activeSubscriber?.id !== subscriber_id) {
      const data = {
        switch_subscriber_id: subscriber_id,
      };
      dispatch(switchAccount(data)).then((res) => {
        dispatch(handleAccountSwitchLoading(true));
        if (res?.status) {
          if (indicatorData?.length > 0) {
            dispatch(
              removeActivityIndicator(currentUserData?.id, subscriber_id)
            );
          }
          dispatch(getProfile()).then((Profileres) => {
            if (Object?.keys(Profileres).length > 0) {
              setSwitchAccountDrawerOpen(false);
              if (endpoint !== "/chat") {
                handleRedirection(Profileres, false);
              } else {
                handleRedirection(Profileres, true);
              }
            }
          });
        } else {
          dispatch(handleAccountSwitchLoading(false));
        }
      });
    }
  };

  const handleClick = () => {
    if (isTermConditionChecked) {
      setCreateNewOrgAccountDrawerOpen(true);
    } else {
      setCreateNewOrgAccountDrawerOpen(true);
      // setAlertModalOpen(true);
      // setAlertModalOpen(true);
    }
  };

  useEffect(() => {
    dispatch(getAllJoinedAccountList());

  },[])
  return (
    <Box sx={classes.drawerBody}>
      <AlertPopUp
        title={"Alert"}
        bodyContent={"Please Accept Terms and Condition."}
        open={isAlertModalOpen}
        closeModal={setAlertModalOpen}
      />
      <Stack
        direction="row"
        alignItems="center"
        spacing={2}
        sx={classes.header}
      >
        <Typography sx={classes.iconDiv}>
          <CloseIcon
            sx={classes.iconn}
            onClick={() => setSwitchAccountDrawerOpen(false)}
          />
        </Typography>
        <Typography color={"black"}>Switch Account</Typography>
      </Stack>
      <Typography
        sx={{
          fontSize: fontSizeSchemes.font16,
          fontWeight: 400,
          color: "#183243",
          margin: "0.5rem 0.5rem 1.2rem 0.5rem",
        }}
      >
        Switch accounts to create groups, add team members, and post content in
        the selected account.
      </Typography>

      <>
        <Box width={"95%"} ml={"0.5rem"} mt={"1rem"}>
          <Box
            overflow={"auto"}
            maxHeight={"380px"}
            width={"100%"}
            sx={{
              "&::-webkit-scrollbar": {
                width: "4px",
              },
              "&::-webkit-scrollbar-track": {
                background: "#f1f1f1",
              },
              "&::-webkit-scrollbar-thumb": {
                background: "#888",
                borderRadius: "3px",
                padding: "0px 2px",
              },
            }}
          >
            {joinedAccountList?.data?.map((data) => (
              <Box
                key={data?.id + "switchaccount"}
                onClick={() => handleAccountSwitch(data?.id)}
                sx={{
                  cursor: "pointer",
                  borderRadius: "2px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
                mb={"0.72rem"}
                p={"0.5rem 1rem"}
                color="black"
              >
                {/* Profile Image **/}
                <Box width="1.50rem" height="1.50rem" mr="1.2rem">
                  <img
                    style={{
                      width: "100%",
                      height: "100%",
                    }}
                    src={data?.profileImgUrl || PersonIcon}
                    alt=""
                  />
                </Box>

                {/* User Details */}
                <Box flex={1}>
                  <Typography fontSize={"0.9rem"} fontWeight={400}>
                    {data?.subscriberFirmName}
                  </Typography>
                  <Typography variant="body2">
                    {getAccountTypeLabel(data?.subscriberAccountType)}
                  </Typography>
                </Box>

                {currentUserData?.activeSubscriber?.id === data?.id && (
                  <img src={Tick} sx={{ color: "green", fontSize: 22 }} />
                )}
              </Box>
            ))}
          </Box>
        </Box>

        <Box
          position={"absolute"}
          left={"0.5rem"}
          bottom={"1.5rem"}
          width={"calc(100% - 1rem)"}
        >
          {/* <Box display={"flex"}>
            <FormControlLabel
              sx={{
                ".MuiFormControlLabel-label": {
                  fontSize: "0.85rem",
                },
              }}
              control={
                <Checkbox
                  onChange={(e) => setTermConditionChecked(e.target.checked)}
                  size="medium"
                  sx={{ "& .MuiSvgIcon-root": { color: "#183243" } }}
                />
              }
              // label="To add a new organisation account, I accept the Arkchat Terms of Service"
              labelPlacement="end"
            />
            <Typography>
              To add a new organisation account, I accept the Arkchat{" "}
              <Link
                href={"https://www.arkchat.com/terms-of-service/"}
                underline="none"
                target="_blank"
                rel="noopener"
              >
                Terms of Service
              </Link>
            </Typography>
          </Box> */}
          <Box marginTop={"2rem"} textAlign={"center"}>
            <Button
              sx={{
                borderColor: "#585858",
                color: "#000000",
                textTransform: "none",
              }}
              variant="outlined"
              onClick={handleClick}
            >
              Add Workspace account
            </Button>
            <Typography
              sx={{
                color: "#183243",
                fontSize: fontSizeSchemes.font14,
                fontWeight: 400,
                marginTop: "1rem",
                textAlign: "left",
              }}
            >
              A workspace is a shared team space. Use your company, department,
              or any name you like. Create groups, add members, and work
              together.
            </Typography>
          </Box>
        </Box>
      </>
    </Box>
  );
};

export default SwitchAccount;
